// CRA inlines REACT_APP_* at build time. When REACT_APP_BACKEND_URL is
// unset, concatenating it with the API path produces a relative URL whose
// first segment is the word "undefined", and the host answers 405.
// Production on Railway does not set the variable, so same-origin "/api"
// is the fallback.

function normalizeOrigin(configured) {
    if (typeof configured !== "string") return "";
    const trimmed = configured.trim().replace(/\/+$/, "");
    if (!trimmed || trimmed === "undefined" || trimmed === "null") return "";
    return trimmed;
}

/**
 * API base. "/api" when REACT_APP_BACKEND_URL is missing or blank.
 * With an origin, `${origin}/api` (no double slash).
 *
 * A path argument is joined on:
 *   apiBase("/studio/guest/verify") -> "/api/studio/guest/verify"
 *   apiBase("/api/studio/exports/1/file") stays a single /api prefix
 *     so export download URLs are not turned into /api/api/...
 */
export function apiBase(path, configured = process.env.REACT_APP_BACKEND_URL) {
    const origin = normalizeOrigin(configured);
    const base = origin ? `${origin}/api` : "/api";
    if (path == null || path === "") return base;
    if (typeof path !== "string") return base;
    if (/^https?:\/\//i.test(path)) return path;
    if (path === "/api" || path.startsWith("/api/") || path.startsWith("/api?")) {
        return origin ? `${origin}${path}` : path;
    }
    const suffix = path.startsWith("/") ? path : `/${path}`;
    return `${base}${suffix}`;
}
